import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
import { environment } from "../../../../../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-college-scholarship-create",
  templateUrl: "./college-scholarship-create.component.html",
  styleUrls: ["./college-scholarship-create.component.scss"],
})
export class CollegeScholarshipCreateComponent implements OnInit {
  public tinyConfig = {
    base_url: '/assets/tinymce',
    suffix: '.min',
    height: 400,
    menubar: true,
    plugins: 'code table link image lists',
    apiKey: '',
    toolbar: 'undo redo | bold italic underline | alignleft aligncenter alignright | bullist numlist | table | link image | code',
  };
  @Input() record: any;          // ✅ data for edit
  @Input() collegeId: string;    // ✅ college id from parent
  @Output() formSaved = new EventEmitter<void>();  // ✅ notify parent
  @Output() cancel = new EventEmitter<void>();     // ✅ cancel event
  public Form: FormGroup;
  submitted = false;
  message = null;
  class = null;
  action = null;
  isShown: boolean = false;
  course = [];
  keywords = [];
  streams = [];
  colleges = []; // Added colleges array


  constructor(
    private ActivatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private router: Router
  ) { }

  ngOnInit() {
    let role = localStorage.getItem("userRole");
    let user = localStorage.getItem("userId");

    this.action = "Submit";

    // Get college ID from route parameters
    this.ActivatedRoute.params.subscribe((params) => {
      this.collegeId = params["id"];
      console.log('College ID from route:', this.collegeId);

      if (this.collegeId) {
        // Load existing scholarship data if editing
        this.http
          .get<any>(`${environment.apiUrl}/collegescholarship/${this.collegeId}`, {
            headers: {
              Userinfo: JSON.stringify({
                _id: localStorage.getItem("adminSess"),
                role: localStorage.getItem("userRole"),
              }),
            },
          })
          .subscribe(
            (data) => {
              if (data.message == "Logged Out!") {
                this.router.navigateByUrl("/auth/login");
                return;
              }
              if (data != "") {
                this.action = "Update";
                this.Form.patchValue({
                  _id: data._id,
                  reviews: data.reviews,
                  college: data.college,
                  course: data.course,
                  keywords: data.keywords,
                  streams: data.streams,
                  description: data.description,
                });
              }
            },
            (err: HttpErrorResponse) => {
              console.error("Error loading scholarship data:", err);
            }
          );

        // Load scholarship by college ID
        this.http
          .get<any>(`${environment.apiUrl}/collegescholarship/bycollegeId?college=${this.collegeId}`, {
            headers: {
              Userinfo: JSON.stringify({
                _id: localStorage.getItem("adminSess"),
                role: localStorage.getItem("userRole"),
              }),
            },
          })
          .subscribe(
            (data) => {
              if (data.message == "Logged Out!") {
                this.router.navigateByUrl("/auth/login");
                return;
              }
              if (data && data.results && data.results.length > 0) {
                this.action = "Update";
                this.Form.patchValue({
                  _id: data.results[0]._id,
                  college: data.results[0].college,
                });
              }
            },
            (err: HttpErrorResponse) => {
              console.error("Error loading scholarship by college ID:", err);
            }
          );
      }
    });

    // Initialize form
    this.Form = this.formBuilder.group({
      reviews: ["", [Validators.required]],
      college: [this.collegeId || "", Validators.required], // Set college ID from route
      description: ["", Validators.required],
      course: ["", Validators.required],
      keywords: ["", Validators.required],
      streams: ["", Validators.required],
      _id: [""],
    });
    if (this.record) {
      this.action = "Update";
      this.Form.patchValue(this.record);
    } else {
      this.action = "Submit";
      this.Form.patchValue({ college: this.collegeId });
    }

    // Load colleges dropdown
    this.http
      .get<any>(`${environment.apiUrl}/college/`, {
        headers: {
          Userinfo: JSON.stringify({
            _id: localStorage.getItem("adminSess"),
            role: localStorage.getItem("userRole"),
          }),
        },
      })
      .subscribe(
        (data) => {
          if (data.message == "Logged Out!") {
            this.router.navigateByUrl("/auth/login");
            return;
          }
          this.colleges = data.results || data;
        },
        (err: HttpErrorResponse) => {
          console.error("Error loading colleges:", err);
        }
      );

    // Load courses dropdown
    this.http
      .get<any>(`${environment.apiUrl}/course/`, {
        headers: {
          Userinfo: JSON.stringify({
            _id: localStorage.getItem("adminSess"),
            role: localStorage.getItem("userRole"),
          }),
        },
      })
      .subscribe(
        (data) => {
          if (data.message == "Logged Out!") {
            this.router.navigateByUrl("/auth/login");
            return;
          }
          this.course = data.results || data;
        },
        (err: HttpErrorResponse) => {
          console.error("Error loading courses:", err);
        }
      );

    // Load keywords dropdown
    this.http
      .get<any>(`${environment.apiUrl}/keywords/`, {
        headers: {
          Userinfo: JSON.stringify({
            _id: localStorage.getItem("adminSess"),
            role: localStorage.getItem("userRole"),
          }),
        },
      })
      .subscribe(
        (data) => {
          if (data.message == "Logged Out!") {
            this.router.navigateByUrl("/auth/login");
            return;
          }
          this.keywords = data.results || data;
        },
        (err: HttpErrorResponse) => {
          console.error("Error loading keywords:", err);
        }
      );

    // Load streams dropdown
    this.http
      .get<any>(`${environment.apiUrl}/streams/`, {
        headers: {
          Userinfo: JSON.stringify({
            _id: localStorage.getItem("adminSess"),
            role: localStorage.getItem("userRole"),
          }),
        },
      })
      .subscribe(
        (data) => {
          if (data.message == "Logged Out!") {
            this.router.navigateByUrl("/auth/login");
            return;
          }
          this.streams = data.results || data;
        },
        (err: HttpErrorResponse) => {
          console.error("Error loading streams:", err);
        }
      );
  }

  get f() {
    return this.Form.controls;
  }

  onFormSubmit() {
    this.submitted = true;

    if (this.Form.invalid) {
      console.log('Form is invalid');
      return;
    }

    // Prepare data for API - ensure college ID is properly passed
    const formData = this.Form.value;
    const data = {
      reviews: formData.reviews,
      description: formData.description,
      college: formData.college, // This should be the college ID
      course: formData.course,
      streams: formData.streams,
      keywords: formData.keywords,
    };

    console.log('Submitting scholarship data:', data);

    if (this.action == "Submit") {
      this.http
        .post<any>(`${environment.apiUrl}/collegescholarship/`, data, {
          headers: {
            Userinfo: JSON.stringify({
              _id: localStorage.getItem("adminSess"),
              role: localStorage.getItem("userRole"),
            }),
          },
        })
        .subscribe(
          (res) => {
            if (res.message == "Logged Out!") {
              this.router.navigateByUrl("/auth/login");
              return;
            }
            if (res.status == "500") {
              this.message = res.message;
              this.class = "btn-primary rounded px-1 py-1";
            } else {
              this.message = "Successfully Added";
              this.class = "btn-success rounded px-1 py-1";
              this.router.navigateByUrl("/college-details/college-scholarship-list");
              this.formSaved.emit();   // ✅ emit on success
            }
          },
          (err: HttpErrorResponse) => {
            console.error("Error creating scholarship:", err);
            this.message = "Error creating scholarship";
            this.class = "btn-danger rounded px-1 py-1";
          }
        );
    } else {
      let id = this.Form.value._id;

      this.http
        .patch<any>(`${environment.apiUrl}/collegescholarship/${id}`, data, {
          headers: {
            Userinfo: JSON.stringify({
              _id: localStorage.getItem("adminSess"),
              role: localStorage.getItem("userRole"),
            }),
          },
        })
        .subscribe(
          (res) => {
            if (res.message == "Logged Out!") {
              this.router.navigateByUrl("/auth/login");
              return;
            }
            if (res.status == "500") {
              this.message = res.message;
              this.class = "btn-primary rounded px-1 py-1";
            } else {
              this.message = "Successfully Updated";
              this.class = "btn-success rounded px-1 py-1";
              this.router.navigateByUrl("/college-details/college-scholarship-list");
              this.formSaved.emit();   // ✅ emit on success
            }
          },
          (err: HttpErrorResponse) => {
            console.error("Error updating scholarship:", err);
            this.message = "Error updating scholarship";
            this.class = "btn-danger rounded px-1 py-1";
          }
        );
    }
  }
  onCancel() {
    if (this.cancel.observers.length > 0) {
      // 🔹 Case 1: Opened inside modal (popup)
      this.cancel.emit();
    } else {
      // 🔹 Case 2: Opened as a standalone routed page
      this.router.navigateByUrl("/college-details/college-scholarship-list");
    }
  }
}